import { render, staticRenderFns } from "./SalesTaxSubscription.vue?vue&type=template&id=be3672f6&"
import script from "./SalesTaxSubscription.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./SalesTaxSubscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports